/**
 * Shared demolition constants. Projectile numbers live in services so
 * damageModel can import them without a cycle through structures.
 */

export {
  CANNONBALL_RADIUS,
  CANNONBALL_DENSITY,
  CANNONBALL_SPEED,
  SPIKE_RADIUS,
  SPIKE_DENSITY,
  SPIKE_SPEED,
  RUBBLE_RADIUS,
  RUBBLE_DENSITY,
  RUBBLE_SPEED,
  CHARGE_RADIUS,
  CHARGE_DENSITY,
  CHARGE_SPEED,
  CONCUSSION_RADIUS,
  CONCUSSION_DENSITY,
  CONCUSSION_SPEED,
} from '../../services/projectileConstants';

export const MAX_LAUNCH_SPEED = 18;
export const MAX_SUBFRACTURE_BODIES_PER_SHOT = 48;
export const BLAST_VOLLEY_SUB_BUDGET = 64;
/**
 * Per-event sub-fracture body cap. The profile budget is the material identity
 * (stone = rare splits). Sphere/blast events additionally cannot exceed the
 * remaining shared volley pool — they must not replace that identity with 64.
 */
export function subFractureBudgetForEvent(
  footprintKind: string,
  profileBudget: number,
  volleyRemaining: number,
): number {
  if (footprintKind === 'sphere') return Math.min(volleyRemaining, profileBudget);
  return profileBudget;
}
export const MAX_DYNAMIC_CHUNKS = 240;
export const MAX_LIVE_CELLS_MUL = 4;
